export const setWebName = (state, param) => {
  state.webName = param.data.data.web_name
}

export const setBusinessId = (state, value) => {
  state.rmp_business.business_id = value.data.data.business_id
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/mutations.js